import React from 'react';
import R from 'ramda';
import { connect } from 'react-redux';
import { Dialog } from 'react-toolbox/lib/dialog';
import { getOrcidDialogVisible } from 'contact-info/contactInfoReducer';
import { SHOW_ORCID_DIALOG } from 'contact-info/contactInfoActions';
import theme from 'shared-styles/DialogTheme.css';

const OrcidDialog = ({ visible, onOk }) =>
  <Dialog
    actions={[{ label: 'OK', onClick: onOk }]}
    active={visible}
    onEscKeyDown={onOk}
    onOverlayClick={onOk}
    title="ORCID"
    theme={theme}
  >
    <p>
      Your ORCID uniquely identifies you to ensure that you aren't confused with
      someone else with a similar name. You can use your ORCID to identify
      yourself for all of your research and publishing activities. Learn more
      at:{' '}
      <a href="https://orcid.org" target="_blank" rel="noopener noreferrer">
        https://orcid.org
      </a>
    </p>
  </Dialog>;

const mapState = R.pipe(
  R.path(['contactInfo']),
  R.applySpec({
    visible: getOrcidDialogVisible,
  }),
);

const mapDispatch = dispatch => ({
  onOk: () => dispatch({ type: SHOW_ORCID_DIALOG, show: false }),
});

export default connect(mapState, mapDispatch)(OrcidDialog);



// WEBPACK FOOTER //
// ./src/contact-info/components/OrcidDialog.js